import * as React from 'react';

const SvgRefresh = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <g mask='url(#mask0_7316_23404)'>
      <path
        d='M15.48 5.70732C15.8705 5.3168 15.8705 4.68363 15.48 4.29311L11.975 0.788086L10.3628 2.40022L11.8146 3.852C9.62207 3.89443 7.75385 4.6927 6.21834 6.24472C4.64015 7.83989 3.84998 9.77797 3.84998 12.0502C3.84998 12.7635 3.9434 13.4602 4.13034 14.14C4.31728 14.8197 4.59744 15.4816 4.97016 16.1254L5.06798 16.2943L6.78249 14.5798L6.73414 14.4831C6.53902 14.0929 6.39306 13.6953 6.29583 13.2902C6.19862 12.8851 6.14998 12.4719 6.14998 12.0502C6.14998 10.4057 6.71817 9.01479 7.85642 7.86841C8.9502 6.76681 10.2655 6.19582 11.8102 6.15284L10.3628 7.60022L11.975 9.21235L15.48 5.70732Z'
        fill='var(--colorIconPrimary)'
      />
      <path
        d='M19.0298 7.87506L18.932 7.7061L17.2175 9.4206L17.2658 9.5173C17.4609 9.90753 17.6069 10.3051 17.7041 10.7102C17.8013 11.1153 17.85 11.5285 17.85 11.9502C17.85 13.5947 17.2818 14.9856 16.1435 16.132C15.0498 17.2336 13.7344 17.8046 12.1897 17.8476L13.6371 16.4002L12.025 14.7881L8.51995 18.2931C8.12943 18.6836 8.12943 19.3168 8.51995 19.7073L12.025 23.2123L13.6371 21.6002L12.1853 20.1484C14.3779 20.106 16.2461 19.3077 17.7816 17.7557C19.3598 16.1605 20.15 14.2225 20.15 11.9502C20.15 11.2369 20.0565 10.5402 19.8696 9.86045C19.6827 9.1807 19.4025 8.51886 19.0298 7.87506Z'
        fill='var(--colorIconPrimary)'
      />
    </g>
  </svg>
);

export default SvgRefresh;
